import { getUserHasLoan } from 'app/queries/decoratedSilo';
import { useMemo } from 'react';
import { useThisDecoratedSilo } from '../silo/silo';
import { calculateLTVFromDecoratedSilo, LTV } from '../util/ltv';

export const useLTV = (): LTV | null => {
  const decoratedSilo = useThisDecoratedSilo();

  return useMemo(() => {
    const userHasLoan = getUserHasLoan(decoratedSilo);

    if (!userHasLoan) return null;

    return calculateLTVFromDecoratedSilo(decoratedSilo);
  }, [decoratedSilo]);
};
